<template>
    <div>
        <Loading v-if="loading" />

        <div class="bg-gray-50 h-screen flex items-center justify-center">
            <BaseCard v-if="order.data.id" class="max-w-2xl w-full" title="Detail Order" description="Detail Order">
                <div class="space-y-4 border-t pt-4">
                    <p class="text-gray-600">Halo <strong class="text-gray-900">{{ shareLink.data.attributes.data.customer_name }}</strong>, ini rincian pesanan Anda:</p>
                    <Datatable :columns="[
                        { id: 'product_name', name: 'Produk' },
                        { id: 'product_qty', name: 'Jumlah' }
                    ]">
                        <template #tbody="{ classes }">
                            <tr v-for="product  in products.data" :key="product.id">
                                <td :class="classes.td">{{ product.attributes.product_code }}</td>
                                <td :class="[classes.td, 'text-right']">{{ product.attributes.product_qty }}</td>
                            </tr>
                        </template>
                        <template #tfoot="{ classes }">
                            <tr :class="[classes.tr, 'bg-gray-50']">
                                <td :class="[classes.td, 'text-right']">Ongkir</td>
                                <td :class="[classes.td, 'text-right']">
                                    <p v-if="order.data.attributes.shipment_method === 'pickup'">Diambil</p>
                                    <p v-else>({{ order.data.attributes.courier_code }} {{ order.data.attributes.courier_service }}) {{ order.data.attributes.shipping_cost | toCurrency }}</p>
                                </td>
                            </tr>
                        </template>
                    </Datatable>
                    <p class="text-gray-600">Lihat rinciannya di <a :href="shareLink.data.attributes.link_url" class="text-green-600 font-bold">{{ shareLink.data.attributes.link_url }}</a>.</p>
                </div>
            </BaseCard>
            <BaseCard v-else-if="packet.data.id" class="max-w-2xl w-full" :title="packet.data.attributes.title" :description="packet.data.attributes.description">
                <div class="space-y-4 border-t pt-4">
                    <p class="text-gray-600">Halo <strong class="text-gray-900">{{ shareLink.data.attributes.data.customer_name }}</strong>, ini rincian pesanan Anda:</p>
                    <Datatable :columns="[
                        { id: 'product_code', name: 'Produk' },
                        { id: 'product_qty', name: 'Jumlah' }
                    ]">
                        <template #tbody="{ classes }">
                            <tr v-for="product  in packetDetails.data" :key="product.id">
                                <td :class="classes.td">{{ product.attributes.product_code }}</td>
                                <td :class="classes.td">{{ product.attributes.product_qty }}</td>
                            </tr>
                        </template>
                    </Datatable>
                    <p class="text-gray-600">Lihat rinciannya di <a :href="shareLink.data.attributes.link_url" class="text-green-600 font-bold">{{ shareLink.data.attributes.link_url }}</a>.</p>
                </div>
            </BaseCard>
            <BaseCard v-else-if="multiProductLink.data.id" class="max-w-2xl w-full">
                <div class="space-y-4">
                    <p class="text-gray-600">Halo <strong class="text-gray-900">{{ shareLink.data.attributes.data.customer_name }}</strong>, ini rincian pesanan Anda:</p>
                    <div class="grid sm:grid-cols-2 gap-4">
                        <div  class="w-full">
                            <dt class="text-sm text-gray-700">Area</dt>
                            <dd class="mt-1 text-gray-700 font-bold">
                                {{ multiProductLink.data.attributes.area }}
                            </dd>
                        </div>
                        <div  class="w-full">
                            <dt class="text-sm text-gray-700">Total Harga</dt>
                            <dd class="mt-1 text-gray-700 font-bold">
                                {{ multiProductLink.data.attributes.total_price | toCurrency }}
                            </dd>
                        </div>
                    </div>
                    <Datatable :columns="[
                        { id: 'product_code', name: 'Produk' },
                        { id: 'product_name', name: 'Nama' },
                        { id: 'product_price', name: 'Harga' }
                    ]">
                        <template #tbody="{ classes }">
                            <tr v-for="product in multiProductLinkItems.data" :key="product.id">
                                <td :class="classes.td">{{ product.attributes.product_code }}</td>
                                <td :class="classes.td">{{ product.attributes.product_name }}</td>
                                <td :class="classes.td">{{ product.attributes.selected_price | toCurrency }}</td>
                            </tr>
                        </template>
                    </Datatable>
                    <p class="text-gray-600">Lihat rinciannya di <a :href="shareLink.data.attributes.link_url" class="text-green-600 font-bold">{{ shareLink.data.attributes.link_url }}</a>.</p>
                </div>
            </BaseCard>
            <BaseCard v-else-if="detailProduct.data.id" class="max-w-2xl w-full" :title="detailProduct.data.attributes.code" :description="detailProduct.data.attributes.name">
                <div class="space-y-4 border-t pt-4 mb-4">
                    <Carousel :per-page="1" :pagination-padding="4">
                        <Slide v-for="media in detailProductMedia.data" :key="media.id">
                            <img :src="media.attributes.fileurl" alt="">
                        </Slide>
                    </Carousel>
                </div>

                <p class="text-gray-600 mb-4">Halo <strong class="text-gray-900">{{ shareLink.data.attributes.data.customer_name }}</strong>.</p>
                
                <div  class="w-full">
                    <dt class="text-xs text-gray-700">Deskripsi</dt>
                    <dd class="mt-1 text-sm text-gray-700">
                        {{ detailProduct.data.attributes.description ?? 'Tidak ada deskripsi.' }}
                    </dd>
                </div>
            </BaseCard>
        </div>
    </div>
</template>

<script>
import { requestMixin } from '../mixins/request/request';
import { Carousel, Slide } from 'vue-carousel';

export default {
    mixins: [requestMixin],
    components: {
        Carousel,
        Slide
    },
    data() {
        return {
            loading: true,
            shareLink: {
                data: {
                    attributes: {
                        data: {}
                    }
                }
            },
            order: {
                data: {
                    attributes: {}
                }
            },
            products: {
                data: []
            },
            packet: {
                data: {
                    attributes: {}
                }
            },
            packetDetails: {
                data: []
            },
            multiProductLink: {
                data: {
                    attributes: {}
                }
            },
            multiProductLinkItems: {
                data: []
            },
            detailProduct: {
                data: {
                    attributes: {}
                }
            },
            detailProductMedia: {
                data: []
            },
        }
    },
    methods: {
        async loadData() {
            const [res, err] = await this.request(`/api/v1/share-links/-actions/patch`, {
                method: 'post',
                data: {
                    code: this.$route.params.code
                }
            })

            if (err) {
                this.$router.push('/')
            } else {
                this.shareLink = res

                if (res.data.attributes.linkable_type === 'App\\Models\\OrderPrompt') {
                    this.loadProducts(res)
                } else if (res.data.attributes.linkable_type === 'App\\Models\\ProductPacket') {
                    this.loadPacket(res)
                } else if (res.data.attributes.linkable_type === 'App\\Models\\MultiProductLink') {
                    this.loadMultiProductLink(res)
                } else {
                    this.loadDetailProduct(res)
                }
            }

            this.loading = false
        },
        async loadProducts(link) {
            const [order, err] = await this.request(`/api/v1/share-links/${link.data.id}/-actions/get-order-prompt`)

            if (!err) {
                this.order = order
                
                const [products, err] = await this.request(`/api/v1/order-prompts/${order.data.id}/products`)

                if (!err) {
                    this.products = products
                }
            }
        },
        async loadPacket(link) {
            const [packet, err] = await this.request(`/api/v1/share-links/${link.data.id}/-actions/get-product-packet`)

            if (!err) {
                this.packet = packet
                
                const [details, err] = await this.request(`/api/v1/product-packets/${packet.data.id}/details`)

                if (!err) {
                    this.packetDetails = details
                }
            }
        },
        async loadMultiProductLink(link) {
            const [multiProductLink, err] = await this.request(`/api/v1/share-links/${link.data.id}/-actions/get-multi-product-link`)

            if (!err) {
                this.multiProductLink = multiProductLink
                
                const [items, err] = await this.request(`/api/v1/multi-product-links/${multiProductLink.data.id}/items`)

                if (!err) {
                    this.multiProductLinkItems = items
                }
            }
        },
        async loadDetailProduct(link) {
            const [res, err] = await this.request(`/api/v1/share-links/${link.data.id}/-actions/get-product`)

            if (!err) {
                this.detailProduct = res

                const [medias, err] = await this.request(`/api/v1/products/${res.data.id}/product-media`)

                if (!err) {
                    this.detailProductMedia = medias
                }
            }
        }
    },
    created() {
        this.loadData()
    }
}
</script>